import { PriorityHigh } from "@mui/icons-material";

export const priority = (props) => {
  return <PriorityHigh {...props} />;
};
